import { Category }   from './client/pages/Category';
import { Game }       from './client/pages/Game';
import { Help }       from './client/pages/Help';
import { Home }       from './client/pages/Home';
import { P404Page }   from './client/pages/p404';
import { Search }     from './client/pages/Search';

const bases = ['/', '/en/', '/es/', '/fr/', '/de/', '/it/'];

const page2component = {
    'category/:category': Category,
    'games/:game': Game,
    'search/:game': Search,
    'help': Help,
    '404': P404Page,
    '': Home,
};

export const routes = bases.reduce((acc, base) => ([
    ...acc,
    ...(
        Object.keys(page2component)
        .map(page => ({
            exact: true,
            path: base + page,
            component: page2component[page],
        }))
    ),
    {
        path: '*',
        is404: true,
        component: P404Page,
    },
]), []);
